import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class vehicleAddItemCtrl implements IController {

  vehicleId: any;
  excludeIds: any;
  onAdd: Function;

  private vehicle: any;

  /* @ngInject */
  constructor(private $vehicles, private $scope: IScope) {
  }

  $onInit() {
    this.vehicle = undefined;

    if (!this.excludeIds) {
      this.excludeIds = [];
    }
    if (this.vehicleId) {
      this.$vehicles(this.vehicleId).$bindCtrlToId(this.$scope, this, 'vehicle', 'vehicleId');
    }
  };

  $onChanges(changes) {
    if (changes.vehicleId && !changes.vehicleId.isFirstChange()) {
      this.$onInit();
    }
  };

  getDisabledValue() {
    if (!this.vehicle) {
      return true;
    }
    return _.findIndex(this.excludeIds, (name) => {
      return this.vehicle.name === name;
    }) !== -1;
  }

}

angular
  .module('bringoz.admin.vehicles')
  .component('vehicleAddItem', {
    bindings: {
      vehicleId: '<',
      excludeIds: '<',
      onAdd: '&'
    },
    template: require('./vehicle-add-item.html').default,
    controller: vehicleAddItemCtrl
  });
